.container {
  width: 100%;
}

.toggle {
  align-items: center;
  border: none;
  border-bottom: 1px solid transparent;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  width: 100%;
}

.toggleExpanded {
  border-bottom-color: var(--color-muted);
}

.icon {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.content {
  padding-left: 1rem;
  padding-right: 1rem;
}
